import { requestWithToken as request } from "./api";

export const getAll = (params = {}) => {
    return request.get("/financial_entity_account/?format=json", params);
};

export const getFinancialEntitys = (params = {}) => {
    return request.get("/financial_entity/?format=json", params);
};

/**
 *
 *

 * @param {{
    updated_at: number
    name: string,
    amount: number,
  }
}
 * }data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const create = (data = {}) => {
    return request.post("/financial_entity_account/?format=json", data);
};

export const updatePartial = (data = {}) => {
    return request.patch(
        `/financial_entity_account/${data.id}/?format=json`,
        data.field
    );
};

export const deleteItem = (id = Number) => {
    return request.delete(`/financial_entity_account/${id}/`);
};

export const disconnectAutomaticItem = (id = Number) => {
    return request.delete(`/fintoc_app/company_account_link/${id}/`);
};

export const bankMovements = (data = {}) => {
    return request.get(`/account_movement/?format=json`, data);
};

export const bankMovementsUpdate = (data = {}) => {
    return request.patch(
        `/account_movement/${data.id}/?format=json`,
        data.field
    );
};

export const bankMovementsHistory = (data = {}) => {
    return request.get(`/cash_flow_history/?format=json`, data);
};
